import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = { class: "assets-grid-card" }
const _hoisted_2 = { class: "assets-grid-card__header" }
const _hoisted_3 = { class: "assets-grid-title" }
const _hoisted_4 = { class: "assets-grid-title__text" }
const _hoisted_5 = { class: "assets-grid-card__body" }
const _hoisted_6 = { class: "wl-console-subtabs" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  key: 0,
  class: "alert alert-danger d-flex align-items-center gap-2 mt-3 mx-3"
}
const _hoisted_9 = {
  key: 1,
  class: "wp-grid-wrap"
}
const _hoisted_10 = {
  key: 0,
  class: "wp-loading wp-loading--overlay"
}
const _hoisted_11 = { class: "wl-assets-search-wrap" }
const _hoisted_12 = ["placeholder"]
const _hoisted_13 = {
  key: 0,
  class: "state-msg text-muted p-4 text-center"
}
const _hoisted_14 = {
  key: 1,
  class: "wl-console-messages"
}
const _hoisted_15 = { class: "wl-console-message__chips" }
const _hoisted_16 = { class: "wl-chip wl-chip--muted" }
const _hoisted_17 = { class: "wl-chip" }
const _hoisted_18 = { class: "wl-chip wl-chip--danger" }
const _hoisted_19 = { class: "wl-chip wl-chip--warning" }
const _hoisted_20 = {
  key: 0,
  class: "wl-chip wl-chip--info"
}
const _hoisted_21 = { class: "wl-chip wl-chip--success" }
const _hoisted_22 = { class: "wl-console-message__hex" }
const _hoisted_23 = { class: "wl-assets-search-wrap" }
const _hoisted_24 = ["placeholder"]
const _hoisted_25 = { class: "font-monospace small" }
const _hoisted_26 = { class: "text-muted small font-monospace" }
const _hoisted_27 = { class: "text-muted small font-monospace" }
const _hoisted_28 = { class: "text-muted small font-monospace" }
const _hoisted_29 = { class: "wl-console-cadence-controls" }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = { value: "" }
const _hoisted_32 = ["value"]
const _hoisted_33 = { class: "table-scroll" }
const _hoisted_34 = { class: "table wl-console-table" }
const _hoisted_35 = { class: "text-end" }
const _hoisted_36 = { class: "text-end" }
const _hoisted_37 = { class: "text-end" }
const _hoisted_38 = { class: "text-end" }
const _hoisted_39 = { class: "font-monospace" }
const _hoisted_40 = { class: "text-end font-monospace" }
const _hoisted_41 = { class: "text-end font-monospace" }
const _hoisted_42 = { class: "text-end font-monospace" }
const _hoisted_43 = { class: "text-end font-monospace text-muted" }
const _hoisted_44 = { key: 0 }
const _hoisted_45 = {
  colspan: "6",
  class: "text-center text-muted p-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxLoadPanel = _resolveComponent("DxLoadPanel")!
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxPager = _resolveComponent("DxPager")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "assets-grid-title__icon" }, [
          _createElementVNode("i", { class: "bi bi-terminal" })
        ], -1)),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('components.infrastructure.console.title')), 1)
        ])
      ]),
      _createElementVNode("span", {
        class: _normalizeClass(["wirepas-status-badge", _ctx.connected ? 'wirepas-status-badge--online' : 'wirepas-status-badge--offline'])
      }, [
        _createElementVNode("span", {
          class: _normalizeClass(["wirepas-status-dot", _ctx.connected ? 'wirepas-status-dot--online' : 'wirepas-status-dot--offline'])
        }, null, 2),
        _createTextVNode(" " + _toDisplayString(_ctx.connected ? _ctx.$t('components.infrastructure.console.brokerOnline') : _ctx.$t('components.infrastructure.console.brokerOffline')), 1)
      ], 2)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.views, (v) => {
          return (_openBlock(), _createElementBlock("button", {
            key: v,
            type: "button",
            class: _normalizeClass(["tab-link", { active: _ctx.view === v }]),
            onClick: ($event: any) => (_ctx.view = v)
          }, _toDisplayString(_ctx.$t(`components.infrastructure.console.views.${v}`)), 11, _hoisted_7))
        }), 128))
      ]),
      (_ctx.error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _cache[4] || (_cache[4] = _createElementVNode("i", { class: "bi bi-exclamation-triangle-fill" }, null, -1)),
            _createElementVNode("span", null, _toDisplayString(_ctx.error), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.hasActivated)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [...(_cache[5] || (_cache[5] = [
                  _createElementVNode("span", {
                    class: "spinner-border wp-loading__spinner",
                    role: "status"
                  }, null, -1)
                ]))]))
              : _createCommentVNode("", true),
            (_ctx.view === 'messages')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("div", _hoisted_11, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.messageSearch) = $event)),
                      type: "text",
                      class: "form-control wl-assets-search",
                      placeholder: _ctx.$t('components.infrastructure.console.searchMessages')
                    }, null, 8, _hoisted_12), [
                      [_vModelText, _ctx.messageSearch]
                    ])
                  ]),
                  (!_ctx.filteredMessages.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.$t('components.infrastructure.console.empty')), 1))
                    : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredMessages, (m, i) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: i,
                            class: "wl-console-message"
                          }, [
                            _createElementVNode("div", _hoisted_15, [
                              _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.formatTs(m.ts)), 1),
                              _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.shortGwId(m.gw_id)) + " / " + _toDisplayString(m.sink_id), 1),
                              _createElementVNode("span", _hoisted_18, _toDisplayString(m.src_addr), 1),
                              _createElementVNode("span", _hoisted_19, _toDisplayString(m.src_ep) + " → " + _toDisplayString(m.dst_ep), 1),
                              (m.hops != null || m.travel_ms != null)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(m.hops != null ? `${m.hops} hop(s)` : '') + _toDisplayString(m.travel_ms != null ? ` ${m.travel_ms} ms` : ''), 1))
                                : _createCommentVNode("", true),
                              _createElementVNode("span", _hoisted_21, _toDisplayString(m.size) + " B", 1)
                            ]),
                            _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.formatHex(m.hex)), 1)
                          ]))
                        }), 128))
                      ]))
                ], 64))
              : (_ctx.view === 'nodes')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createElementVNode("div", _hoisted_23, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.nodeSearch) = $event)),
                        type: "text",
                        class: "form-control wl-assets-search",
                        placeholder: _ctx.$t('components.infrastructure.console.searchNodes')
                      }, null, 8, _hoisted_24), [
                        [_vModelText, _ctx.nodeSearch]
                      ])
                    ]),
                    _createVNode(_component_DxDataGrid, {
                      class: "ni-grid",
                      "data-source": _ctx.filteredNodes,
                      "key-expr": "address",
                      "hover-state-enabled": true,
                      "column-auto-width": true,
                      "word-wrap-enabled": false,
                      "show-borders": false,
                      "show-column-lines": false,
                      "show-row-lines": false,
                      "row-alternation-enabled": true,
                      "no-data-text": _ctx.$t('components.infrastructure.console.empty')
                    }, {
                      "addr-template": _withCtx(({ data }) => [
                        _createElementVNode("span", _hoisted_25, _toDisplayString(data.data.address), 1)
                      ]),
                      "lastts-template": _withCtx(({ data }) => [
                        _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.agoText(data.data.lastTs)), 1)
                      ]),
                      "gwid-template": _withCtx(({ data }) => [
                        _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.shortGwId(data.data.gw_id)), 1)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_DxLoadPanel, { enabled: false }),
                        _createVNode(_component_DxPaging, { "page-size": 15 }),
                        _createVNode(_component_DxPager, {
                          "show-info": true,
                          "show-navigation-buttons": true
                        }),
                        _createVNode(_component_DxColumn, {
                          "data-field": "address",
                          caption: _ctx.$t('components.infrastructure.console.columns.address'),
                          "min-width": 130,
                          "cell-template": "addr-template"
                        }, null, 8, ["caption"]),
                        _createVNode(_component_DxColumn, {
                          "data-field": "lastTs",
                          caption: _ctx.$t('components.infrastructure.console.columns.lastSeen'),
                          "min-width": 150,
                          "sort-order": "desc",
                          "cell-template": "lastts-template"
                        }, null, 8, ["caption"]),
                        _createVNode(_component_DxColumn, {
                          "data-field": "gw_id",
                          caption: _ctx.$t('components.infrastructure.console.columns.gateway'),
                          "min-width": 180,
                          "cell-template": "gwid-template"
                        }, null, 8, ["caption"]),
                        _createVNode(_component_DxColumn, {
                          "data-field": "sink_id",
                          caption: _ctx.$t('components.infrastructure.console.columns.sink'),
                          "min-width": 90
                        }, null, 8, ["caption"]),
                        _createVNode(_component_DxColumn, {
                          "data-field": "count",
                          caption: _ctx.$t('components.infrastructure.console.columns.count'),
                          "min-width": 100,
                          alignment: "center"
                        }, null, 8, ["caption"])
                      ]),
                      _: 1
                    }, 8, ["data-source", "no-data-text"])
                  ], 64))
                : (_ctx.view === 'gateways')
                  ? (_openBlock(), _createBlock(_component_DxDataGrid, {
                      key: 3,
                      class: "ni-grid",
                      "data-source": _ctx.gateways,
                      "key-expr": "gw_id",
                      "hover-state-enabled": true,
                      "column-auto-width": true,
                      "word-wrap-enabled": false,
                      "show-borders": false,
                      "show-column-lines": false,
                      "show-row-lines": false,
                      "row-alternation-enabled": true,
                      "no-data-text": _ctx.$t('components.infrastructure.console.empty')
                    }, {
                      "cgwid-template": _withCtx(({ data }) => [
                        _createElementVNode("span", _hoisted_28, _toDisplayString(data.data.gw_id), 1)
                      ]),
                      "online-template": _withCtx(({ data }) => [
                        _createElementVNode("span", {
                          class: _normalizeClass(["wirepas-status-badge", data.data.online ? 'wirepas-status-badge--online' : 'wirepas-status-badge--offline'])
                        }, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["wirepas-status-dot", data.data.online ? 'wirepas-status-dot--online' : 'wirepas-status-dot--offline'])
                          }, null, 2),
                          _createTextVNode(" " + _toDisplayString(data.data.online ? _ctx.$t('components.infrastructure.online') : _ctx.$t('components.infrastructure.offline')), 1)
                        ], 2)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_DxLoadPanel, { enabled: false }),
                        _createVNode(_component_DxPaging, { "page-size": 15 }),
                        _createVNode(_component_DxPager, {
                          "show-info": true,
                          "show-navigation-buttons": true
                        }),
                        _createVNode(_component_DxColumn, {
                          "data-field": "gw_id",
                          caption: _ctx.$t('components.infrastructure.console.columns.gateway'),
                          "min-width": 190,
                          "cell-template": "cgwid-template"
                        }, null, 8, ["caption"]),
                        _createVNode(_component_DxColumn, {
                          "data-field": "model",
                          caption: _ctx.$t('components.infrastructure.console.columns.model'),
                          "min-width": 150
                        }, null, 8, ["caption"]),
                        _createVNode(_component_DxColumn, {
                          "data-field": "version",
                          caption: _ctx.$t('components.infrastructure.console.columns.version'),
                          "min-width": 110
                        }, null, 8, ["caption"]),
                        _createVNode(_component_DxColumn, {
                          "data-field": "sinkCount",
                          caption: _ctx.$t('components.infrastructure.console.columns.sinks'),
                          "min-width": 90,
                          alignment: "center"
                        }, null, 8, ["caption"]),
                        _createVNode(_component_DxColumn, {
                          "data-field": "online",
                          caption: _ctx.$t('components.infrastructure.console.columns.status'),
                          "min-width": 120,
                          alignment: "center",
                          "cell-template": "online-template"
                        }, null, 8, ["caption"])
                      ]),
                      _: 1
                    }, 8, ["data-source", "no-data-text"]))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                      _createElementVNode("div", _hoisted_29, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cadenceWindows, (w) => {
                          return (_openBlock(), _createElementBlock("button", {
                            key: w.sec,
                            type: "button",
                            class: _normalizeClass(["tab-link", { active: _ctx.cadenceWindowSec === w.sec }]),
                            onClick: ($event: any) => (_ctx.cadenceWindowSec = w.sec)
                          }, _toDisplayString(w.label), 11, _hoisted_30))
                        }), 128)),
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.cadenceAddr) = $event)),
                          class: "form-select form-select-sm wl-console-cadence-select"
                        }, [
                          _createElementVNode("option", _hoisted_31, _toDisplayString(_ctx.$t('components.infrastructure.console.allAddresses')), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cadence.addrs, (a) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: a,
                              value: a
                            }, _toDisplayString(a), 9, _hoisted_32))
                          }), 128))
                        ], 512), [
                          [_vModelSelect, _ctx.cadenceAddr]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_33, [
                        _createElementVNode("table", _hoisted_34, [
                          _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                              _createElementVNode("th", null, _toDisplayString(_ctx.$t('components.infrastructure.console.columns.endpoint')), 1),
                              _createElementVNode("th", null, _toDisplayString(_ctx.$t('components.infrastructure.console.columns.packetType')), 1),
                              _createElementVNode("th", _hoisted_35, _toDisplayString(_ctx.$t('components.infrastructure.console.columns.packets')), 1),
                              _createElementVNode("th", _hoisted_36, _toDisplayString(_ctx.$t('components.infrastructure.console.columns.avgInterval')), 1),
                              _createElementVNode("th", _hoisted_37, _toDisplayString(_ctx.$t('components.infrastructure.console.columns.perMinute')), 1),
                              _createElementVNode("th", _hoisted_38, _toDisplayString(_ctx.$t('components.infrastructure.console.columns.lastPacket')), 1)
                            ])
                          ]),
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cadence.endpoints, (e) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: e.ep
                              }, [
                                _createElementVNode("td", _hoisted_39, _toDisplayString(e.ep), 1),
                                _createElementVNode("td", null, _toDisplayString(e.label), 1),
                                _createElementVNode("td", _hoisted_40, _toDisplayString(e.count), 1),
                                _createElementVNode("td", _hoisted_41, _toDisplayString(_ctx.formatDur(e.avgIntervalMs)), 1),
                                _createElementVNode("td", _hoisted_42, _toDisplayString(e.ratePerMin), 1),
                                _createElementVNode("td", _hoisted_43, _toDisplayString(_ctx.formatDur(e.lastAgoMs)), 1)
                              ]))
                            }), 128)),
                            (!_ctx.cadence.endpoints.length)
                              ? (_openBlock(), _createElementBlock("tr", _hoisted_44, [
                                  _createElementVNode("td", _hoisted_45, _toDisplayString(_ctx.$t('components.infrastructure.console.empty')), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ])
                    ], 64))
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}